import { createReducer } from './utils.js';
import {
  GET_FAQ_DASHBOARD_SUMMARY_REQUEST,
  GET_FAQ_DASHBOARD_SUMMARY_SUCCESS,
  GET_FAQ_DASHBOARD_SUMMARY_FAILURE,
  GET_FAQ_STATS_REQUEST,
  GET_FAQ_STATS_SUCCESS,
  GET_FAQ_STATS_FAILURE,
  UPDATE_FAQ_QUESTION_REQUEST,
  UPDATE_FAQ_QUESTION_SUCCESS,
  UPDATE_FAQ_QUESTION_FAILURE,
  SET_FAQ_DAYS_FILTER,
  SNACK_SET,
} from './constants.js';

const defaultState = {
  loading: false,
  errorMessage: null,
  summary: {
    cards: [],
    faq_table: []
  },
  faqStats: [],
  metrics: [],
  daysFilter: 30
};

export const reducer = createReducer(defaultState, {
  [GET_FAQ_DASHBOARD_SUMMARY_REQUEST]: handleGetFaqDashboardSummaryRequest,
  [GET_FAQ_DASHBOARD_SUMMARY_SUCCESS]: handleGetFaqDashboardSummarySuccess,
  [GET_FAQ_DASHBOARD_SUMMARY_FAILURE]: handleGetFaqDashboardSummaryFailure,
  [GET_FAQ_STATS_REQUEST]: handleGetFaqStatsRequest,
  [GET_FAQ_STATS_SUCCESS]: handleGetFaqStatsSuccess,
  [GET_FAQ_STATS_FAILURE]: handleGetFaqStatsFailure,
  [SET_FAQ_DAYS_FILTER]: handleSetFaqDaysFilter,
});

// Reducer handler functions
function handleGetFaqDashboardSummaryRequest(state) {
  return {
    ...state,
    loading: true,
    errorMessage: null,
  };
}

function handleGetFaqDashboardSummarySuccess(state, { payload: { summary } }) {
  return {
    ...state,
    summary,
    loading: false,
    errorMessage: null,
  };
}

function handleGetFaqDashboardSummaryFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}

function handleGetFaqStatsRequest(state) {
  return {
    ...state,
    loading: true,
    errorMessage: null,
  };
}

function handleGetFaqStatsSuccess(state, { payload: { faqStats } }) {
  return {
    ...state,
    faqStats,
    loading: false,
    errorMessage: null,
  };
}

function handleGetFaqStatsFailure(state, { payload: { error } }) {
  return {
    ...state,
    loading: false,
    errorMessage: error,
  };
}

function handleSetFaqDaysFilter(state, { payload: { days } }) {
  return {
    ...state,
    daysFilter: days,
  };
}

// Action creators
export function getFaqDashboardSummary(period, tenant_id, sucursal_id) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: GET_FAQ_DASHBOARD_SUMMARY_REQUEST });
    try {
      const params = {
        tenant_id,
        sucursal_id,
      };
      if (typeof period === 'number') {
        params.days = period;
      } else if (
        typeof period === 'object' &&
        period.start_date &&
        period.end_date
      ) {
        params.start_date = period.start_date;
        params.end_date = period.end_date;
      }
      const response = await dataSource.getDashboardSummary(params);
      dispatch({ 
        type: GET_FAQ_DASHBOARD_SUMMARY_SUCCESS, 
        payload: { summary: response} 
      });
    } catch (error) {
      dispatch({ 
        type: GET_FAQ_DASHBOARD_SUMMARY_FAILURE, 
        payload: { error: error.message || 'Failed to fetch dashboard data' } 
      });
      const snack = {
        open: true,
        message: 'Error al obtener estadísticas del dashboard: ' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function getFaqStats(tenant_id, sucursal_id) {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: GET_FAQ_STATS_REQUEST });
    try {
      
      const params = {
        tenant_id,
        sucursal_id
      };
      
      const response = await dataSource.getFaqStats(params);
      dispatch({ 
        type: GET_FAQ_STATS_SUCCESS, 
        payload: { faqStats: response } 
      });
    } catch (error) {
      dispatch({ 
        type: GET_FAQ_STATS_FAILURE, 
        payload: { error: error.message || 'Failed to fetch FAQ stats' } 
      });
      const snack = {
        open: true,
        message: 'Error al obtener estadísticas de preguntas frecuentes: ' + error.message,
        severity: 'error',
      };
      dispatch({ type: SNACK_SET, payload: { snack } });
    }
  };
}

export function setFaqDaysFilter(days) {
  return {
    type: SET_FAQ_DAYS_FILTER,
    payload: { days },
  };
} 